import { render, staticRenderFns } from "./shop_detail.vue?vue&type=template&id=58b9fba6&scoped=true&"
import script from "./shop_detail.vue?vue&type=script&lang=js&"
export * from "./shop_detail.vue?vue&type=script&lang=js&"
import style0 from "./shop_detail.vue?vue&type=style&index=0&id=58b9fba6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58b9fba6",
  null
  
)

export default component.exports